import { render, staticRenderFns } from "./v-tributos.vue?vue&type=template&id=0fa42dd7&"
import script from "./v-tributos.js?vue&type=script&lang=js&"
export * from "./v-tributos.js?vue&type=script&lang=js&"
import style0 from "./v-tributos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports